import { config } from '~/config';

import { impersonatedIds } from './axios';

export const TRIALS_API_ROOT = config.trialsApiRoot;
export const TRIALS_NEST_API_ROOT = `${config.trialsApiRoot}/nest`;

export const V1_DOCUMENTS = `${TRIALS_API_ROOT}/v1/documents`;
export const V1_PATIENTS = `${TRIALS_API_ROOT}/v1/patients`;
export const V1_TRIALS = `${TRIALS_API_ROOT}/v1/trials`;
export const V2_PATIENT_TRACKER = `${TRIALS_API_ROOT}/v2/patient-tracker`;
export const V2_TIME_NOTIFICATIONS = `${TRIALS_API_ROOT}/v2/time-notifications`;
export const V2_TIME_PATIENTS = `${TRIALS_API_ROOT}/v2/time-patients`;
export const V3_TIME_PRESCREENING = `${TRIALS_NEST_API_ROOT}/v3/time-prescreening`;

export const NEXT_PRESCREENING = `${TRIALS_NEST_API_ROOT}/next-prescreening`;
export const PATIENT_QUERY = `${TRIALS_NEST_API_ROOT}/patient-query`;
export const PATIENT_COHORT_MATCH = `${TRIALS_NEST_API_ROOT}/v1/patient-cohort-match`;
export const TRIALS_PATIENTS = `${TRIALS_NEST_API_ROOT}/v1/trials-patients`;
export const NEXT_PATIENT_TRACKING = `${TRIALS_NEST_API_ROOT}/next-patient-tracking`;

export const UPLOAD_TIMEOUT = 60000 * 5;

const PROVIDER_REPORTING_IMPERSONATION_HEADER = 't-impersonate-institutions';

export const getSelectedSiteId = (): string => {
  if (impersonatedIds.length > 0) {
    return impersonatedIds[0];
  }

  const storedSelectedUserSite = localStorage.getItem('selectedUserSite');

  if (!storedSelectedUserSite) {
    return '';
  }

  try {
    const parsedSelectedUserSite = JSON.parse(storedSelectedUserSite) as { id?: string };

    return parsedSelectedUserSite.id ?? '';
  } catch {
    return '';
  }
};

export const getProviderReportingRequestConfig = (): { headers?: Record<string, string> } => {
  const siteId = getSelectedSiteId();

  if (!siteId) {
    return {};
  }

  return {
    headers: {
      [PROVIDER_REPORTING_IMPERSONATION_HEADER]: siteId,
    },
  };
};

export const omitUndefinedQueryParams = <T extends Record<string, unknown>>(params: T): Partial<T> =>
  Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined)) as Partial<T>;
